import { IApplicationState } from '../../types/redux';
import { initialState } from '../../reducers/seoData';

export const selectSeoData = (state: IApplicationState) => state.seoData || initialState;
